import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'mainNavItem',
  title: 'Main Nav Item',
  type: 'object',
  fields: [
    defineField({
      name: 'link',
      type: 'link',
      title: 'Link',
    }),
    defineField({
      title: 'Sub Nav?',
      name: 'hasSubNav',
      type: 'string',
      options: {
        list: [
          { title: 'None', value: '' },
          { title: 'Photos', value: 'photo' },
          { title: 'Info', value: 'info' },
          { title: 'Vehicles', value: 'vehicles' },
          { title: 'Wheels', value: 'wheels' },
        ],
      },
      initialValue: '',
    }),
    defineField({
      name: 'photoSubNav',
      type: 'photoSubNav',
      title: 'Photo Sub Nav',
      hidden: ({ parent }) => parent?.hasSubNav !== 'photo',
    }),
    defineField({
      name: 'infoSubNav',
      type: 'infoSubNav',
      title: 'Info Sub Nav',
      hidden: ({ parent }) => parent?.hasSubNav !== 'info',
    }),
  ],
  preview: {
    select: {
      link: 'link',
    },
    prepare(selection) {
      const { title = 'New nav item...' } = selection?.link || {}
      return {
        title,
        subtitle: '',
      }
    },
  },
})